module.exports = __webpack_public_path__ + "static/media/ThinkQuickSmallBassy.5af5dc7b.mp3";